module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "acknowPage"
  }, [_c('div', {
    staticClass: "title-acknowPage"
  }, [_c('a', {
    attrs: {
      "href": "#/e9781466813120_toc01#toctitle1",
      "id": "title1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgments")])])])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p"
  }, [_c('span', [_vm._v("THOUGH WRITING is a profoundly solitary activity, it is one that can be made easier or more difficult by the interpersonal relationships of the writer outside her workroom. I am fortunate in having a cluster of people who support me and my writing in various ways. Many heartfelt thanks belong to:")])]), _vm._v(" "), _c('div', {
    staticClass: "p-blanc"
  }, [_c('span', [_c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Victor Parra and Jude Parra-Sickels, who graciously leave me alone at my desk for many, many hours and who tolerate my distracted state of mind at those times when I’ve left my desk but not my story; Brian McDonnell, inveterate alchemist, who got "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Walking")]), _vm._v(" West its first reading at a publisher; Marilyn Monaco-Han, who will talk books and writing into the wee hours; Tom McGovern, who punctuates the family’s progress with meals and photographs; my writing group, Jacqueline de Angelis, Lynette Prucha, and Terry Wolverton, who manage to bestow the right combination of praise and challenge; Carol Hoover of Ariadne Press, whose interest in the first draft of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Walking West")]), _vm._v(" encouraged me to plunge into the second; Tom Epley of The Potomac Literary Agency, who has been my long-distance shepherd and champion; Hope Dellon and Jenny Notz of St. Martin’s Press, who shed on my manuscript careful, intelligent, ardent attention; and Bertha “Snooky” Sickels, my mother, who was not alive to read one word of "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Walking West,")]), _vm._v(" but who long ago imparted to me her passionate attachment to language and books. I wish to acknowledge, too, the nineteenth-century women and men whose diaries, letters, and reminiscences of westward migration were the backbone of my research for "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Walking West.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e518ed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781466813120_ack01.vue
// module id = 66
// module chunks = 0